import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { PracticePlacementServiceData } from 'shell/models/practice-lists';
import { ItemVM } from 'shell/view-models/item';

interface PracticePlacementServiceListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (value?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const PracticePlacementServiceListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Servizio inserimento pratica',
  id = 'practice-placement-service-list',
}: PracticePlacementServiceListComponentProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseList<PracticePlacementServiceData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/servizi-inserimento`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<PracticePlacementServiceData>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.codiceServizio || '',
          value: item.descrizione || '',
        }));
      },
    }
  );

  const dataList = (list.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="type-label">
        {label}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(dataList as Array<ItemVM>)?.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

PracticePlacementServiceListComponent.displayName = 'PracticePlacementService List component';

const PracticePlacementServiceList = memo(PracticePlacementServiceListComponent);

export default PracticePlacementServiceList as typeof PracticePlacementServiceListComponent;
